export * from "./location.model"; //todo geht es?
export * from "./onBoarding.model"; //todo geht es?

export * from "./blackWhiteList.model";
export * from "./navigation.model";
export * from "./item_group.model";
export * from "./menu.model";
export * from "./product.model";
export * from "./reservation.model";
export * from "./bonussystem.model";
export * from "./checkout.model";
export * from "./news.model";
export * from "./coupon.model";
export * from "./like.model";
export * from "./rating.model";
export * from "./feedback.model";
export * from "./event.model";
export * from "./impressum.model";
export * from "./term.model";
export * from "./homeContent.model";
export * from "./valueStorage.model";
export * from "./settings.model";
export * from "./ExternalLinksSettings.model";
export * from "./webshop.model";
export * from "./userOrderHistory.model";
export * from "./socket.model";
export * from "./servicecall.model";
export * from "./recipeLinking.model";
export * from "./web_voucher.model";
export * from "./webshopLanguages.model";
export * from "./webshopColorTokens.model";